import { api, API } from "@/lib/api";

const mem = new Map();
const CACHE = "pg-images-v1";

async function cacheStore() {
  try { return "caches" in window ? await caches.open(CACHE) : null; } catch { return null; }
}

export function loadImage(fileId, variant = "thumb") {
  const key = `${fileId}_${variant}`;
  if (mem.has(key)) return mem.get(key);
  const p = (async () => {
    const reqUrl = `${API}/files/${fileId}?variant=${variant}`;
    const store = await cacheStore();
    let blob = null;
    if (store) { const hit = await store.match(reqUrl); if (hit) blob = await hit.blob(); }
    if (!blob) {
      const r = await api.get(`/files/${fileId}`, { params: { variant }, responseType: "blob" });
      blob = r.data;
      if (store) store.put(reqUrl, new Response(blob, { headers: { "Content-Type": blob.type || "image/jpeg" } })).catch(() => {});
    }
    return URL.createObjectURL(blob);
  })();
  p.catch(() => mem.delete(key));
  mem.set(key, p);
  return p;
}

export function primeImage(fileId, variant, blob) {
  const key = `${fileId}_${variant}`;
  mem.set(key, Promise.resolve(URL.createObjectURL(blob)));
  cacheStore().then((s) => s && s.put(`${API}/files/${fileId}?variant=${variant}`, new Response(blob, { headers: { "Content-Type": blob.type || "image/jpeg" } })).catch(() => {}));
}

let prefetched = false;
export async function prefetchInventoryImages(force = false) {
  if (prefetched && !force) return;
  prefetched = true;
  try {
    const { data } = await api.get("/inventory", { params: { limit: 1000 } });
    const ids = data.items.map((i) => i.image_file_id).filter(Boolean);
    let idx = 0;
    const worker = async () => { while (idx < ids.length) { const id = ids[idx++]; try { await loadImage(id, "thumb"); } catch {} } };
    await Promise.all(Array.from({ length: 2 }, worker));
  } catch { prefetched = false; }
}
